<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>
            DANH SÁCH CÁC THÀNH VIÊN TRONG DÒNG HỌ
            <span class="text-dongHo">{{ tenDongHo }}</span>
          </h3>

          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <!-- <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới nốt gia phả</el-button
            > -->
          </div>
        </div>
        <!-- <div class="title-dong-ho">
          <b-row>
            <b-col lg="6">
              <div class="mr-2">Dòng họ:</div>
              <el-select
                v-model="id"
                @change="fn_changeDongHo"
                placeholder="Chọn tên dòng họ"
                filterable
                clearable
                style="width: 533px"
              >
                <el-option
                  v-for="item in ten_array"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </b-col>
          </b-row>
        </div> -->

        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Họ tên">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['ten.ho_ten']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Năm sinh (dương)">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['sinh.nam_duong']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Năm mất (dương)">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['mat.nam_duong']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Trạng thái">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['duoc_duyet']
                          "
                          placeholder="Chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.optionsDuocDuyet"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Kích hoạt">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['kich_hoat']
                          "
                          placeholder="Chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.optionsKichHoat"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Trạng thái"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <div class="group-status">
                    <div v-if="scope.row.gui_yeu_cau === true" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Đã gửi yêu cầu"
                        placement="top"
                      >
                        <i
                          class="fa-solid fa-paper-plane icon-da-gui fs-22"
                        ></i>
                      </el-tooltip>
                    </div>

                    <div v-if="scope.row.duoc_duyet === false" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Chờ duyệt"
                        placement="top"
                      >
                        <i
                          class="fa-solid fa-circle-check icon-cho-duyet fs-22"
                        ></i>
                      </el-tooltip>
                    </div>

                    <div v-if="scope.row.duoc_duyet === true" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Đã duyệt"
                        placement="top"
                      >
                        <i
                          class="fa-solid fa-circle-check icon-da-duyet fs-22"
                        ></i>
                      </el-tooltip>
                    </div>

                    <div v-if="scope.row.kich_hoat === false" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Chưa kích hoạt"
                        placement="top"
                      >
                        <i
                          class="fa-solid fa-user icon-chua-kich-hoat fs-22"
                        ></i>
                      </el-tooltip>
                    </div>

                    <div v-if="scope.row.kich_hoat === true" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Đã kích hoạt"
                        placement="top"
                      >
                        <i class="fa-solid fa-user icon-da-kich-hoat fs-22"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="scope.row.trong_ho === true" class="text-box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Trong họ"
                        placement="top"
                      >
                        <i
                          class="fa-solid fa-circle-heart icon-trong-ho fs-22"
                        ></i>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ten.ho_ten"
                label="Tên"
                min-width="150"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>

              <el-table-column
                prop="gioi_tinh"
                label="Giới tính"
                align="center"
                width="100"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                prop="sinh.ngay_sinh"
                label="Ngày sinh"
                min-width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="mat.ngay_mat"
                label="Ngày mất"
                min-width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="Đời"
                prop="so_doi"
                width="50"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="cha_me_1_ten"
                label="Tên cha/mẹ"
                min-width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="thoi_diem_tao"
                label="Ngày tạo"
                min-width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="thoi_diem_cap_nhat"
                label="Ngày cập nhật"
                min-width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="170px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('add', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_addNode"
                    type="warning"
                  >
                    <i class="fas fa-user-plus"></i>
                  </el-button>
                  <!-- <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <div
              class="mt-2 d-flex justify-content-between"
              v-if="mData.tableRules.allowPaging"
            >
              <div>
                <el-button
                  type="primary"
                  @click="fn_exportExcel_ds_thanh_vien_dong_ho()"
                  v-ladda
                  ><i class="far fa-file-export"></i> Xuất danh sách thành
                  viên</el-button
                >
              </div>
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>

            <el-collapse @change="handleThemNotDongHo" class="mt-5">
              <el-collapse-item>
                <template slot="title">
                  <i class="fas fa-user-plus"></i> THÀNH VIÊN CỦA DÒNG HỌ
                </template>
                <b-row class="mt-2 mb-2">
                  <b-col md="8">
                    <el-switch
                      style="display: block"
                      v-model="value2"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="Thêm thành viên trong dòng họ"
                      inactive-text="Thêm con"
                    >
                    </el-switch>
                  </b-col>
                  <b-col md="4">
                    <el-select
                      v-model="valueNguoiTrongHo"
                      placeholder="Chọn người trong họ"
                      :disabled="value2"
                      @change="fn_getNguoiDungId"
                      clearable
                      @input="forceUpdateUI"
                    >
                      <el-option
                        v-for="item in nguoiTrongHo"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </b-col>
                </b-row>

                <div class="upload">
                  <text-reader @load="text = $event"></text-reader>
                </div>

                <textarea
                  placeholder="Nhập nội dung thành viên trong dòng họ hoặc chọn tải file"
                  v-model="text"
                  rows="13"
                  style="width: 100%"
                  ref="textBox"
                  id="textBox"
                ></textarea>
              </el-collapse-item>
            </el-collapse>
            <div class="text-center mt-3">
              <el-button
                type="primary"
                v-show="showUploadBtn"
                @click="fn_back()"
                v-ladda
                plain
                >quay lại</el-button
              >
              <el-button
                type="primary"
                v-show="showUploadBtn"
                :disabled="text == ''"
                v-if="value2"
                @click="fn_uploadNotDongHo"
                ><i class="fas fa-cloud-upload-alt"></i> Tải lên</el-button
              >
              <el-button
                type="primary"
                v-show="showUploadBtn"
                :disabled="text == '' || nguoiDungId == ''"
                v-if="!value2"
                @click="fn_uploadNotConDongHo"
                ><i class="fas fa-cloud-upload-alt"></i> Tải lên</el-button
              >
            </div>
          </div>

          <el-dialog
            title="Thêm thành viên"
            :visible.sync="showThemNot"
            width="50%"
            center
            :before-close="beforeClose"
          >
            <div class="name-node">
              <i class="fas fa-share-alt"></i> {{ nameNode }}
            </div>
            <div class="add-box-group">
              <button
                class="add-box"
                :disabled="isChaMe"
                id="chame"
                @click="btnThemQuanHe('chame')"
              >
                <i class="fa-regular fa-plus"></i>
                <p>Bố, Mẹ</p>
              </button>
              <button
                class="add-box"
                :disabled="isVoChong"
                id="vochong"
                @click="btnThemQuanHe('vochong')"
              >
                <i class="fa-regular fa-plus"></i>
                <p>Vợ, Chồng</p>
              </button>
              <button
                class="add-box"
                :disabled="isAnhChiEm"
                id="anhchiem"
                @click="btnThemQuanHe('anhchiem')"
              >
                <i class="fa-regular fa-plus"></i>
                <p>Anh, Chị</p>
              </button>
              <button
                class="add-box"
                :disabled="isEm"
                id="em"
                @click="btnThemQuanHe('em')"
              >
                <i class="fa-regular fa-plus"></i>
                <p>Em</p>
              </button>
              <button
                class="add-box"
                :disabled="isCon"
                id="con"
                @click="btnThemQuanHe('con')"
              >
                <i class="fa-regular fa-plus"></i>
                <p>Con</p>
              </button>
            </div>
            <el-form>
              <b-row>
                <b-col xl="6">
                  <el-form-item label="Họ và tên">
                    <el-input
                      placeholder="Nhập tên thành viên gia phả"
                      v-model="inputTenNot"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col xl="4" class="male-top">
                  <el-form-item label="Giới tính">
                    <el-radio
                      v-model="gioiTinh"
                      label="nam"
                      style="margin-right: 20px"
                      :disabled="disabledGioiTinh"
                      >Nam</el-radio
                    >
                    <el-radio
                      v-model="gioiTinh"
                      label="nu"
                      :disabled="disabledGioiTinh"
                      >Nữ</el-radio
                    >
                  </el-form-item>
                </b-col>
                <b-col xl="2" style="margin-top: 46px"
                  ><el-checkbox
                    v-model="trongHo"
                    @change="fn_changeTrongHo"
                    v-show="showTrongHo"
                    >Trong họ</el-checkbox
                  ></b-col
                >
              </b-row>
            </el-form>
            <div class="d-flex justify-content-center">
              <el-button @click="fn_hideThemNot()">Hủy</el-button>
              <el-button
                v-if="buttonThemQuanHe == 'chame'"
                type="primary"
                @click="fn_themChaMe()"
                :disabled="inputTenNot.trim() == '' || gioiTinh == ''"
                >Thêm mới</el-button
              >
              <el-button
                v-if="buttonThemQuanHe == 'anhchiem'"
                type="primary"
                @click="fn_themAnhChi()"
                :disabled="inputTenNot.trim() == '' || gioiTinh == ''"
                >Thêm mới</el-button
              >
              <el-button
                v-if="buttonThemQuanHe == 'em'"
                type="primary"
                @click="fn_themEm()"
                :disabled="inputTenNot.trim() == '' || gioiTinh == ''"
                >Thêm mới</el-button
              >
              <el-button
                v-if="buttonThemQuanHe == 'con'"
                type="primary"
                @click="fn_themCon()"
                :disabled="inputTenNot.trim() == '' || gioiTinh == ''"
                >Thêm mới</el-button
              >
              <el-button
                v-if="buttonThemQuanHe == 'vochong'"
                type="primary"
                @click="fn_themVoChong()"
                :disabled="inputTenNot.trim() == '' || gioiTinh == ''"
                >Thêm mới</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormNodeGiaPha";
import TextReader from "../../../component/FileReader";

export default {
  data() {
    return {
      tenDongHo: "",
      ngay_sinh: "",
      value: "",
      value2: true, // switch
      ten_array: [],
      aLang: LanguageService.lang,
      loading: false,
      showThemNot: false,
      nameNode: "",
      trongHo: false,
      showTrongHo: false, // show lựa chọn trong họ
      showTrongHoKhiThemBoMe: false,
      gioiTinh: "", // giới tính của nốt thêm mới
      gioiTinhNode: "", // giới tính của nốt hiện tại
      moiQuanHe: "",
      buttonThemQuanHe: "", // button thay đổi fn_add theo tình trạng mối quan hệ (có 4)
      inputTenNot: "",
      nodeId: "", // id của nốt hiện tại khi bấm nút thêm nốt gia phả
      chaMe1Id: "", // id cha mẹ 1 của nốt hiện tại
      voChongId: "", // id vợ hoặc chồng của nốt hiện tại
      gioiTinhChaMe1Id: "", // giới tính cha mẹ 1 id
      valueNguoiTrongHo: "",
      nguoiTrongHo: [], // danh sách người trong 1 họ dùng để thêm con trực tiếp
      nguoiDungId: "", // nguoi_dung_id dùng cho thêm nốt con cho nốt người dùng id đó
      text: "",
      showUploadBtn: false,
      doiTruocId: [],
      isChaMe: false,
      isAnhChiEm: false,
      isCon: false,
      isEm: false,
      voChong: false,
      isVoChong: false, // disabled giới tính
      disabledGioiTinh: false, // disabled giới tính
      isSelectVoChong: false,
      isSelectChaMe: false,
      lengthNodeGiaPha: 0,
      mData: {
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        quanHe: MethodService.copyObject(DataForm.quanHe),
        optionsDuocDuyet: MethodService.copyObject(DataForm.duocDuyet),
        optionsKichHoat: MethodService.copyObject(DataForm.kichHoat),
      },
    };
  },
  components: {
    Circle4,
    TextReader,
  },
  methods: {
    async fn_changeData(data) {
      const resQuyenHan = await mushroom.dong_ho.findByIdAsync({
        id: this.$router.currentRoute.params.id, // required
      });
      let arr = [];
      data.forEach((e) => {
        if (e.quan_he && e.quan_he.cha_me_1_id) arr.push(e);
      });
      let arr1 = arr.map((e) =>
        mushroom.node_gia_pha.listAsync({
          fields: "id,ten",
          filters: [
            "dong_ho_id=" + e.dong_ho_id,
            "id=" + e.quan_he.cha_me_1_id,
          ],
        })
      );
      let dataName = [];
      await Promise.allSettled(arr1).then((x) => {
        x.forEach((item) => {
          if (item.status === "fulfilled") {
            item.cha_me_1_ten = item.value.result[0].ten.ho_ten;
          }
        });
        dataName = x;
      });
      // lấy thông tin thời điểm kích hoạt
      let nguoidungActiveArray = data.map((e) =>
        mushroom.nguoi_dung.listAsync(
          {
            fields: "id,thoi_diem_kich_hoat",
            filters: ["id=" + e.nguoi_dung_id],
          },
          {
            enabledCache: false,
          }
        )
      );
      await Promise.all(nguoidungActiveArray).then((dataValue) => {
        dataValue.forEach((dataValueItem) => {
          data.forEach((item) => {
            if (dataValueItem.result[0].id === item.nguoi_dung_id) {
              if (dataValueItem.result[0].thoi_diem_kich_hoat) {
                item.thoi_diem_kich_hoat = MethodService.formatDate(
                  dataValueItem.result[0].thoi_diem_kich_hoat,
                  "datetime"
                );
              } else item.thoi_diem_kich_hoat = "";
            }
          });
        });
      });
      //lấy thông tin thời điểm duyệt
      let nguoidungCheckArray = data.map((e) =>
        mushroom.node_gia_pha.listAsync(
          {
            fields: "id,thoi_diem_duyet",
            filters: ["id=" + e.id],
          },
          {
            enabledCache: false,
          }
        )
      );
      await Promise.all(nguoidungCheckArray).then((dataValue) => {
        dataValue.forEach((d) => {
          data.forEach((item) => {
            if (d.result[0].id === item.id) {
              if (d.result[0].thoi_diem_duyet) {
                item.thoi_diem_duyet = MethodService.formatDate(
                  d.result[0].thoi_diem_duyet,
                  "datetime"
                );
              } else item.thoi_diem_duyet = "";
            }
          });
        });
      });
      data.forEach(async (element) => {
        element.so_doi = 1;
        if (element.quan_he && element.quan_he.doi_truoc_1_ids) {
          element.so_doi = element.quan_he.doi_truoc_1_ids.length + 1;
        }
        dataName.forEach((x) => {
          if (x.status === "fulfilled") {
            if (
              element.quan_he &&
              element.quan_he.cha_me_1_id &&
              x.value.result[0].id === element.quan_he.cha_me_1_id
            ) {
              element.cha_me_1_ten = x.value.result[0].ten.ho_ten;
            }
          }
        });
        if (
          resQuyenHan.result.nguoi_quan_lys &&
          resQuyenHan.result.nguoi_quan_lys.length > 0
        ) {
          resQuyenHan.result.nguoi_quan_lys.forEach((x) => {
            if (element.nguoi_dung_id === x.nguoi_dung_id) {
              element.role = x.quyen;
            }
          });
        }

        element.thoi_diem_tao = MethodService.formatDate(
          element.thoi_diem_tao,
          "datetime"
        );
        element.thoi_diem_cap_nhat = MethodService.formatDate(
          element.thoi_diem_cap_nhat,
          "datetime"
        );
        if (element.gioi_tinh == "nu") {
          element.gioi_tinh = "Nữ";
        }
        if (element.gioi_tinh == "nam") {
          element.gioi_tinh = "Nam";
        }

        if (element.sinh) {
          if (element.sinh.ngay_sinh) {
            element.sinh.ngay_sinh = MethodService.formatDate(
              element.sinh.ngay_sinh,
              "date"
            );
          } else if (
            !element.sinh.ngay_sinh &&
            element.sinh.ngay_duong &&
            element.sinh.thang_duong &&
            !element.sinh.nam_duong
          ) {
            element.sinh.ngay_sinh =
              element.sinh.ngay_duong +
              "/" +
              element.sinh.thang_duong +
              " (dương lịch)";
          } else if (
            !element.sinh.ngay_sinh &&
            element.sinh.ngay_duong &&
            element.sinh.nam_duong &&
            !element.sinh.thang_duong
          ) {
            element.sinh.ngay_sinh =
              element.sinh.ngay_duong +
              "/.../" +
              element.sinh.nam_duong +
              " (dương lịch)";
          } else if (
            !element.sinh.ngay_sinh &&
            element.sinh.thang_duong &&
            element.sinh.nam_duong &&
            !element.sinh.ngay_duong
          ) {
            element.sinh.ngay_sinh =
              element.sinh.thang_duong +
              "/" +
              element.sinh.nam_duong +
              " (dương lịch)";
          } else if (
            !element.sinh.ngay_sinh &&
            !element.sinh.ngay_duong &&
            !element.sinh.thang_duong &&
            element.sinh.nam_duong
          ) {
            element.sinh.ngay_sinh = element.sinh.nam_duong + " (dương lịch)";
          } else if (
            !element.sinh.ngay_sinh &&
            element.sinh.ngay_duong &&
            element.sinh.thang_duong &&
            element.sinh.nam_duong
          ) {
            let date = new Date(
              element.sinh.nam_duong,
              element.sinh.thang_duong - 1,
              element.sinh.ngay_duong
            );
            element.sinh.ngay_sinh = MethodService.formatDate(date, "date");
          } else if (
            !element.sinh.ngay_sinh &&
            !element.sinh.ngay_duong &&
            !element.sinh.thang_duong &&
            !element.sinh.nam_duong
          ) {
            let strNgaySinh = "";
            if (element.sinh.ngay_am) {
              strNgaySinh += element.sinh.ngay_am;
            }
            if (element.sinh.thang_am) {
              strNgaySinh += "/" + element.sinh.thang_am;
            }
            if (element.sinh.nam_am) {
              if (strNgaySinh !== "") {
                strNgaySinh += "/" + element.sinh.nam_am;
              } else strNgaySinh = element.sinh.nam_am;
            }
            if (strNgaySinh !== "") {
              strNgaySinh += " (âm lịch)";
            } else strNgaySinh = "";
            element.sinh.ngay_sinh = strNgaySinh;
          }
        }
        if (element.mat) {
          if (element.mat.da_mat) {
            if (element.mat.ngay_mat) {
              element.mat.ngay_mat = MethodService.formatDate(
                element.mat.ngay_mat,
                "date"
              );
            } else if (
              !element.mat.ngay_mat &&
              element.mat.ngay_duong &&
              element.mat.thang_duong &&
              !element.mat.nam_duong
            ) {
              element.mat.ngay_mat =
                element.mat.ngay_duong +
                "/" +
                element.mat.thang_duong +
                " (dương lịch)";
            } else if (
              !element.mat.ngay_mat &&
              element.mat.ngay_duong &&
              element.mat.nam_duong &&
              !element.mat.thang_duong
            ) {
              element.mat.ngay_mat =
                element.mat.ngay_duong +
                "/.../" +
                element.mat.nam_duong +
                " (dương lịch)";
            } else if (
              !element.mat.ngay_mat &&
              element.mat.thang_duong &&
              element.mat.nam_duong &&
              !element.mat.ngay_duong
            ) {
              element.mat.ngay_mat =
                element.mat.thang_duong +
                "/" +
                element.mat.nam_duong +
                " (dương lịch)";
            } else if (
              !element.mat.ngay_mat &&
              !element.mat.ngay_duong &&
              !element.mat.thang_duong &&
              element.mat.nam_duong
            ) {
              element.mat.ngay_mat = element.mat.nam_duong + " (dương lịch)";
            } else if (
              !element.mat.ngay_mat &&
              element.mat.ngay_duong &&
              element.mat.thang_duong &&
              element.mat.nam_duong
            ) {
              element.mat.ngay_mat =
                element.mat.ngay_duong +
                "/" +
                element.mat.thang_duong +
                "/" +
                element.mat.nam_duong;
            } else if (
              !element.mat.ngay_mat &&
              !element.mat.ngay_duong &&
              !element.mat.thang_duong &&
              !element.mat.nam_duong
            ) {
              let strNgayMat = "";
              if (element.mat.ngay_am) {
                strNgayMat += element.mat.ngay_am;
              }
              if (element.mat.ngay_am && element.mat.nam_am) {
                strNgayMat = element.mat.ngay_am + "/.../" + element.mat.nam_am;
              }
              if (element.mat.thang_am && element.mat.nam_am) {
                strNgayMat = element.mat.thang_am + "/" + element.mat.nam_am;
              }
              if (element.mat.ngay_am && element.mat.thang_am) {
                strNgayMat = element.mat.ngay_am + "/" + element.mat.thang_am;
              }
              if (
                element.mat.ngay_am &&
                element.mat.thang_am &&
                element.mat.nam_am
              ) {
                strNgayMat =
                  element.mat.ngay_am +
                  "/" +
                  element.mat.thang_am +
                  "/" +
                  element.mat.nam_am;
              }
              if (
                !element.mat.ngay_am &&
                !element.mat.thang_am &&
                element.mat.nam_am
              ) {
                strNgayMat = element.mat.nam_am;
              }
              if (strNgayMat !== "") {
                strNgayMat += " (âm lịch)";
              } else strNgayMat = "";

              element.mat.ngay_mat = strNgayMat;
            }
          } else element.mat.ngay_mat = "";
        }
      });

      return data;
    },
    async fn_exportExcel_ds_thanh_vien_dong_ho() {
      let dataFilter = {
        fields:
          "id,duoc_duyet,gui_yeu_cau,nguoi_dung_id,kich_hoat,dong_ho_id,trong_ho,quan_he,ten,avatar_id,gioi_tinh,sinh,mat,ky_su,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        filters: this.mData.tableRules.filters,
        sort: "-thoi_diem_tao",
        limit: 9999,
      };
      try {
        const response = await mushroom.node_gia_pha.listAsync(dataFilter, {
          cacheAge: 1,
        });
        if (response.result) {
          let resData = await this.fn_changeData(response.result);
          MethodService.exportExcel(
            resData,
            this.$router.currentRoute.params.id,
            this.tenDongHo
          );
          MethodService.stopLadda();
        }
      } catch (e) {
        console.error(e);
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },

    async fn_initTable() {
      let dataFilter = {
        fields:
          "id,duoc_duyet,gui_yeu_cau,nguoi_dung_id,kich_hoat,dong_ho_id,trong_ho,quan_he,ten,avatar_id,gioi_tinh,sinh,mat,ky_su,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        filters: this.mData.tableRules.filters,
        sort: "-thoi_diem_tao",
      };
      localStorage.setItem("dong_ho_id", this.$router.currentRoute.params.id);
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.page = this.mData.tableRules.page;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachNodeGiaPha",
            query: this.mData.tableRules,
          })
          .catch(() => {});
      }
      try {
        const response = await mushroom.node_gia_pha.listAsync(dataFilter, {
          cacheAge: 1,
        });
        if (response.result) {
          this.lengthNodeGiaPha = response.result.length;
          this.loading = false;
          this.nguoiTrongHo = [];
          let resData = await this.fn_changeData(response.result);
          resData.forEach((element) => {
            this.nguoiTrongHo.push({
              value: element.nguoi_dung_id,
              label: element.ten.ho_ten,
            });
          });
          this.mData.tableRules.data = resData;

          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        console.error(e);
        this.fn_showError(e.code);
      }
    },

    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // tìm kiếm
    async fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachNodeGiaPha",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten.ho_ten"]) {
        this.mData.tableRules.dataSearch.value["ten.ho_ten"] =
          this.mData.tableRules.dataSearch.value["ten.ho_ten"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["sinh.nam_duong"]) {
        this.mData.tableRules.dataSearch.value["sinh.nam_duong"] =
          this.mData.tableRules.dataSearch.value["sinh.nam_duong"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["mat.nam_duong"]) {
        this.mData.tableRules.dataSearch.value["mat.nam_duong"] =
          this.mData.tableRules.dataSearch.value["mat.nam_duong"].trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filters +=
            "&dong_ho_id=" + this.$router.currentRoute.params.id;
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          await this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //hiển thị node gia phả
    async fn_hienThiNode(row) {
      const node_gia_pha_object = {
        id: row.id,
        trong_ho: row.trong_ho,
      };
      try {
        const response = await mushroom.node_gia_pha.partialUpdateAsync(
          node_gia_pha_object
        );
        if (response.result == node_gia_pha_object.id) {
          window.toastr.success("Cập nhật node giả phả thành công");
          // this.fn_initTable(this.mData.tableRules.filters);
          await this.fn_initTable();
        } else window.toastr.warning("Dữ liệu không thay đổi");
      } catch (e) {
        console.error(e);
        this.loading = false;
        this.fn_showError(e.code);
      }
    },

    btnThemQuanHe(event) {
      this.disabledGioiTinh = false;
      this.gioiTinh = "";
      this.showTrongHo = false;
      if (event == "chame" && this.showTrongHoKhiThemBoMe == true) {
        this.showTrongHo = true;
      }
      $("#" + event)
        .siblings()
        .removeClass("select");
      this.buttonThemQuanHe = event;
      $("#" + event).addClass("select");
      if (event == "vochong") {
        if (this.gioiTinhNode == "nam") {
          this.gioiTinh = "nu";
        } else this.gioiTinh = "nam";
        this.disabledGioiTinh = true;
      }
      if (this.chaMe1Id && event == "chame") {
        if (this.gioiTinhChaMe1Id == "nam") {
          this.gioiTinh = "nu";
        } else this.gioiTinh = "nam";
        this.disabledGioiTinh = true;
      }
    },

    // chi tiết, xóa bảng
    async fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietNodeGiaPha",
          params: { nguoi_dung_id: row.nguoi_dung_id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatNodeGiaPha",
          params: { nguoi_dung_id: row.nguoi_dung_id },
        });
      }
      if (type == "add") {
        this.showThemNot = true;

        this.nodeId = row.id; // là id của nốt hiện tại, truyền vào khi thêm cha mẹ cho nốt hiện tại hoặc thêm con cho nốt hiện tại
        let dataFilter = {
          fields:
            "id,duoc_duyet,gui_yeu_cau,nguoi_dung_id,kich_hoat,dong_ho_id,quan_he,trong_ho,ten,avatar_id,gioi_tinh,sinh,mat,ky_su,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
          filters: [
            "dong_ho_id=" + localStorage.getItem("dong_ho_id"),
            "nguoi_dung_id=" + row.nguoi_dung_id,
          ],
        };
        try {
          const response = await mushroom.node_gia_pha.listAsync(dataFilter, {
            cacheAge: 1,
          });
          this.nameNode = response.result[0].ten.ho_ten; // lấy tên nốt hiện tại
          this.chaMe1Id = "";
          this.doiTruocId = [];
          this.isChaMe = false;
          this.isAnhChiEm = false;
          this.isEm = false;
          this.isVoChong = false;
          this.isCon = false;
          this.trongHo = false;
          this.voChongId = "";
          this.showTrongHoKhiThemBoMe = false;
          this.trongHo = response.result[0].trong_ho;

          // nếu ngoài họ chỉ được thêm vợ chồng
          if (this.trongHo == false) {
            this.isChaMe = true;
            this.isCon = true;
            this.isAnhChiEm = true;
            this.isEm = true;
          }
          if (response.result[0].quan_he) {
            // lấy id của cha_me_1_id nếu có dữ liệu
            if (response.result[0].quan_he.cha_me_1_id) {
              this.chaMe1Id = response.result[0].quan_he.cha_me_1_id;
              // lấy thông tin giới tính của cha_me_1_id
              const responseGioiTinhChaMe1Id =
                await mushroom.node_gia_pha.listAsync({
                  filters: ["id=" + this.chaMe1Id],
                });
              this.gioiTinhChaMe1Id =
                responseGioiTinhChaMe1Id.result[0].gioi_tinh;
            }
            if (response.result[0].quan_he.doi_truoc_1_ids) {
              this.doiTruocId = response.result[0].quan_he.doi_truoc_1_ids;
            }

            // nếu ngoài họ và đã có quan hệ vợ chồng thì được thêm con
            if (
              this.trongHo == false &&
              response.result[0].quan_he.danh_sach_vo_chong &&
              response.result[0].quan_he.danh_sach_vo_chong.length > 0
            ) {
              this.isVoChong = true;
              this.isChaMe = true;
              this.isAnhChiEm = true;
              this.isEm = true;
              this.isCon = false;
            }

            // node trên cùng khi thêm bố mẹ được phép chọn trong/ngoài họ
            if (
              !response.result[0].quan_he.cha_me_1_id &&
              !response.result[0].quan_he.cha_me_2_id
            ) {
              this.showTrongHoKhiThemBoMe = true;
            }

            // nếu chưa có bố mẹ thì không được thêm anh chị em
            if (!response.result[0].quan_he.cha_me_1_id) {
              this.isAnhChiEm = true;
              this.isEm = true;
            }
            // nếu đã có đẩy đủ bố, mẹ thì không được thêm nữa
            if (
              response.result[0].quan_he.cha_me_1_id &&
              response.result[0].quan_he.cha_me_2_id
            ) {
              this.isChaMe = true;
            }

            // nếu chưa có bố mẹ thì không được thêm anh, chị, em
            if (!response.result[0].quan_he.cha_me_1_id) {
              this.isAnhChiEm = true;
              this.isEm = true;
            }

            // nếu là ngoài họ(dâu, rể) thì chỉ được thêm con
            if (response.result[0].trong_ho == false) {
              this.isChaMe = true;
              this.isAnhChiEm = true;
              this.isEm = true;
              this.isVoChong = true;
            }

            // nếu node đầu tiên là ngoài họ, phải thêm vợ, chồng trước mới được thêm con
            if (
              response.result[0].trong_ho == false &&
              !response.result[0].quan_he.danh_sach_vo_chong &&
              this.lengthNodeGiaPha == 1
            ) {
              this.isChaMe = true;
              this.isAnhChiEm = true;
              this.isEm = true;
              this.isCon = true;
            }

            // nếu node đang thao tác là ngoài họ và đã có vợ, chồng thì chỉ được thêm con
            if (
              response.result[0].trong_ho == false &&
              response.result[0].quan_he.danh_sach_vo_chong
            ) {
              this.isChaMe = true;
              this.isAnhChiEm = true;
              this.isEm = true;
              this.isVoChong = true;
            }

            // lấy id của vợ/chồng nếu có dữ liệu
            if (response.result[0].quan_he.danh_sach_vo_chong) {
              this.voChongId =
                response.result[0].quan_he.danh_sach_vo_chong[0].node_id;
            }
          }
          if (response.result[0].gioi_tinh) {
            this.gioiTinhNode = response.result[0].gioi_tinh;
          }
        } catch (error) {
          console.error(error);
        }
      }

      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },

    fn_showAdd() {
      // this.showChonQuanHe = false;
      this.showNhapTen = true;
    },
    fn_hideThemNot() {
      this.showThemNot = false;
      this.beforeClose();
    },

    fn_changeTrongHo(event) {
      this.trongHo = event;
    },

    // thêm cha mẹ
    async fn_themChaMe() {
      let fullName = this.inputTenNot.trim();
      let arrName = fullName.split(" ");
      let lastName = arrName.pop();
      const add_node = {
        dong_ho_id: localStorage.getItem("dong_ho_id"),
        quan_he: {
          danh_sach_con: [{ node_id: this.nodeId }],
        },
        ten: {
          ho_ten: fullName,
          ho_dem: fullName.replace(lastName, " ").trim(),
          ten: lastName,
        },
        gioi_tinh: this.gioiTinh,
        trong_ho: this.trongHo,
      };
      if (this.chaMe1Id == "" && this.doiTruocId.length == 0) {
        if (this.trongHo == false) {
          window.toastr.warning("Vui lòng thêm người trong họ trước");
        } else {
          await this.fn_mushroomThemNot(add_node);
        }
      } else {
        const add_node = {
          dong_ho_id: localStorage.getItem("dong_ho_id"),
          quan_he: {
            danh_sach_con: [{ node_id: this.nodeId }],
            danh_sach_vo_chong: [
              {
                node_id: this.chaMe1Id,
                li_di: false,
                da_mat: false,
              },
            ],
          },
          ten: {
            ho_ten: fullName,
            ho_dem: fullName.replace(lastName, " ").trim(),
            ten: lastName,
          },
          trong_ho: false,
        };

        if (this.gioiTinhChaMe1Id == "nam") {
          add_node.gioi_tinh = "nu";
        } else add_node.gioi_tinh = "nam";

        await this.fn_mushroomThemNot(add_node);
      }
    },

    // thêm anh chị
    async fn_themAnhChi() {
      let fullName = this.inputTenNot.trim();
      let arrName = fullName.split(" ");
      let lastName = arrName.pop();
      const add_node = {
        dong_ho_id: localStorage.getItem("dong_ho_id"),
        quan_he: {
          cha_me_1_id: this.chaMe1Id,
        },
        em_id: this.nodeId,
        ten: {
          ho_ten: fullName,
          ho_dem: fullName.replace(lastName, " ").trim(),
          ten: lastName,
        },
        gioi_tinh: this.gioiTinh,
        trong_ho: this.trongHo,
      };
      await this.fn_mushroomThemNot(add_node);
    },

    // thêm con
    async fn_themCon() {
      let fullName = this.inputTenNot.trim();
      let arrName = fullName.split(" ");
      let lastName = arrName.pop();
      const add_node = {
        dong_ho_id: localStorage.getItem("dong_ho_id"),
        ten: {
          ho_ten: fullName,
          ho_dem: fullName.replace(lastName, " ").trim(),
          ten: lastName,
        },
        gioi_tinh: this.gioiTinh,
        trong_ho: true,
      };
      if (this.voChongId.trim() == "") {
        let quanHeKhongVoCoCon = {
          cha_me_1_id: this.nodeId,
        };
        add_node.quan_he = Object.assign({}, quanHeKhongVoCoCon);
      } else {
        let quanHe = {
          cha_me_1_id: this.trongHo ? this.nodeId : this.voChongId,
          cha_me_2_id: this.trongHo ? this.voChongId : this.nodeId,
        };
        add_node.quan_he = Object.assign({}, quanHe);
      }
      await this.fn_mushroomThemNot(add_node);
    },
    async fn_themVoChong() {
      let fullName = this.inputTenNot.trim();
      let arrName = fullName.split(" ");
      let lastName = arrName.pop();
      const add_node = {
        dong_ho_id: localStorage.getItem("dong_ho_id"),
        quan_he: {
          danh_sach_vo_chong: [
            {
              node_id: this.nodeId,
              li_di: false,
              da_mat: false,
            },
          ],
        },
        ten: {
          ho_ten: fullName,
          ho_dem: fullName.replace(lastName, " ").trim(),
          ten: lastName,
        },
        gioi_tinh: this.gioiTinh,
      };
      if (this.trongHo == false) {
        add_node.trong_ho = true;
        this.fn_mushroomThemNot(add_node);
      } else {
        add_node.trong_ho = false;
        this.fn_mushroomThemNot(add_node);
      }
    },
    async fn_themEm() {
      let fullName = this.inputTenNot.trim();
      let arrName = fullName.split(" ");
      let lastName = arrName.pop();
      const add_node = {
        dong_ho_id: localStorage.getItem("dong_ho_id"),
        quan_he: {
          cha_me_1_id: this.chaMe1Id,
        },
        em_id: null,
        ten: {
          ho_ten: fullName,
          ho_dem: fullName.replace(lastName, " ").trim(),
          ten: lastName,
        },
        gioi_tinh: this.gioiTinh,
        trong_ho: this.trongHo,
      };
      await this.fn_mushroomThemNot(add_node);
    },

    beforeClose() {
      this.buttonThemQuanHe = "";
      this.showThemNot = false;
      this.moiQuanHe = "";
      this.inputTenNot = "";
      this.gioiTinh = "";
      this.isChaMe = "";
      this.isVoChong = false;
      this.showTrongHoKhiThemBoMe = false;
      this.showTrongHo = false;
      $("#chame").removeClass("select");
      $("#vochong").removeClass("select");
      $("#anhchiem").removeClass("select");
      $("#con").removeClass("select");
      $("#em").removeClass("select");
    },

    // function chung thêm nốt gia phả
    async fn_mushroomThemNot(object) {
      try {
        const newId = await mushroom.node_gia_pha.themNodeAsync({
          body: object,
        });
        if (newId.result) {
          window.toastr.success("Thêm mới thành viên thành công");
          this.beforeClose();
          this.loading = true;
          await this.fn_initTable();
        }
      } catch (e) {
        console.error(e);
        this.fn_showError(e.code);
        this.beforeClose();
      }
    },

    handleThemNotDongHo() {
      this.showUploadBtn = !this.showUploadBtn;
      this.text = "";
    },
    fn_getNguoiDungId(event) {
      this.nguoiDungId = event;
    },
    // tải lên nốt con cho người trong dòng họ
    async fn_uploadNotConDongHo() {
      const uploadObject = {
        dong_ho_id: this.$router.currentRoute.params.id,
        nguoi_dung_id: this.nguoiDungId,
        text: this.text,
        tao_con: true,
      };

      try {
        const response = await mushroom.dong_ho.importCayGiaPhaAsync({
          body: uploadObject,
        });
        this.text = "";
        window.toastr.success("Tải lên thành công");
      } catch (e) {
        // hiển thị lỗi cụ thể do backend trả về
        console.error(e);
        e.code === 4
          ? window.toastr.error(this.aLang.no_server)
          : e.code === 2
          ? window.toastr.error(this.aLang.server_not_reponse)
          : window.toastr.error(e.message); // lỗi cụ thể do backend trả về
      }
    },
    // tải lên nốt dòng họ
    async fn_uploadNotDongHo() {
      const uploadObject = {
        dong_ho_id: this.$router.currentRoute.params.id,
        nguoi_dung_id: localStorage.getItem("nguoiQuanLyDongHoId"),
        text: this.text,
      };

      try {
        const response = await mushroom.dong_ho.importCayGiaPhaAsync({
          body: uploadObject,
        });
        this.text = "";
        window.toastr.success("Tải lên thành viên dòng họ thành công");
      } catch (e) {
        // hiển thị lỗi cụ thể do backend trả về
        console.error(e);
        e.code === 4
          ? window.toastr.error(this.aLang.no_server)
          : e.code === 2
          ? window.toastr.error(this.aLang.server_not_reponse)
          : window.toastr.error(e.result); // lỗi cụ thể do backend trả về
      }
    },
    fn_back() {
      this.$router.go(-1);
    },
    fn_tabTextArea() {
      this.$refs.textBox.addEventListener("keydown", function (e) {
        if (e.key == "Tab") {
          e.preventDefault();
          var start = this.selectionStart;
          var end = this.selectionEnd;

          // set textarea value to: text before caret + tab + text after caret
          this.value =
            this.value.substring(0, start) + "\t" + this.value.substring(end);

          // put caret at right position again
          this.selectionStart = this.selectionEnd = start + 1;
        }
      });
    },

    fn_showError(maCode) {
      switch (maCode) {
        case 4:
          window.toastr.error(this.aLang.no_server);
          break;
        case 2:
          window.toastr.error(this.aLang.server_not_reponse);
          break;
        default:
          window.toastr.error(this.aLang.has_error);
      }
    },
  },
  //run after render view

  async created() {
    this.mData.tableRules.filters = [
      "dong_ho_id=" + this.$router.currentRoute.params.id,
    ];
    if (localStorage.getItem("tenDongHo")) {
      this.tenDongHo = localStorage.getItem("tenDongHo");
    }
    await this.fn_hashUrl();
    await this.fn_initTable();
    this.fn_tabTextArea();
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.title-btn {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
}
.title-btn p {
  min-width: 75px;
}
.title-dong-ho {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 15px;
}

.name-node {
  background-color: $backgroundPrimary;
  color: $colorPrimary;
  font-size: 18px;
  padding: 7px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  width: fit-content;
}
.add-box {
  border: 1px solid #c8ced3;
  border-radius: 10px;
  height: 50px;
  width: 100%;
  margin: 10px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  transition: 0.3s;
}
.inactive {
  cursor: no-drop;
  background: #f5f5f5;
}
.select {
  background: linear-gradient(#9e1c1e 0 0) padding-box,
    linear-gradient(
        270deg,
        #f9bc60 9.85%,
        #fed9b7 20.64%,
        #ffca78 42.94%,
        #fac766 55.11%,
        #fac96a 65.75%,
        #ffce87 84.81%,
        #e0ab45 99.18%
      )
      border-box;
  background-repeat: no-repeat;
  color: #ffffff;
  padding: 10px;
  border: 5px solid transparent;
  border-radius: 15px;
  display: flex;
  margin: 75px 0;
}
.add-box-group {
  display: block;
  text-align: center;
  margin-top: 30px;
}
#textBox {
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  padding-left: 10px;
}
#textBox:focus {
  outline: none;
}
.upload {
  display: flex;
  margin-bottom: 10px;
}
.text-dongHo {
  text-transform: uppercase;
  color: #f56c6c;
  font-weight: 600;
}
@media (min-width: 960px) {
  .add-box-group {
    display: flex;
    justify-content: center;
  }
  .add-box {
    height: 130px;
    width: 110px;
    margin: 0 10px;
  }
  .add-box:hover {
    transform: scale(1.1);
    box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  }
}
@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
@media (min-width: 1360px) {
  .male-top {
    margin-top: 40px;
  }
}
</style>
